module.exports = __webpack_public_path__ + "static/media/hero_final_final_fiiiiinal.50c27026.png";